import { createApi, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { DEVICE_INFO_API_URL } from '../../config';
import { deviceAxiosQuery } from '../../utils/axios/device.axios';

export const ttsApi = createApi({
  reducerPath: 'ttsApi',
  baseQuery: deviceAxiosQuery(),
  endpoints: (builder) => ({
    generateSpeech: builder.mutation<Blob, string>({
      queryFn: async (text: string) => {
        try {
          const response = await fetch(`${DEVICE_INFO_API_URL}/tts`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ text, voice: 'alloy' }),
          });

          if (!response.ok) {
            return {
              error: {
                status: response.status,
                data: await response.text(),
              } as FetchBaseQueryError,
            };
          }
          const blob = await response.blob();
          return { data: blob };
        } catch (err) {
          const error = err as { message: string }
          return {
            error: {
              status: 500,
              data: error.message,
            } as FetchBaseQueryError,
          };
        }
      },
    }),
  }),
});

export const { useGenerateSpeechMutation } = ttsApi;
